import Vue from 'vue';
import router from './router';
import store from './store';
import './mixins';
import root from '@/views/root';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import VueCookies from 'vue-cookies';
import VueMeta from 'vue-meta';
import vSelect from 'vue-select';
import * as filters from './filters/filters';

Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
});
Vue.component('v-select', vSelect);
Vue.use(VueMeta);
Vue.config.productionTip = false;

Vue.use(VueCookies);
Vue.$cookies.config('365d');

const getClientId = setInterval(() => {
    const gaGlobal = window.gaGlobal;
    if (gaGlobal) {
        const ClientId = gaGlobal.vid;
        // this.$store.dispatch('setGaClientId', ClientId);
        localStorage.setItem('ga-client-id', ClientId);
        clearInterval(getClientId);
    }
}, 10);

new Vue({
    router,
    store,
    render: (h) => h(root),
}).$mount('#app');
